export const paths = {
  HOME: "/",
  ABOUT: "/about",
  AMENITIES: "/amenites",
  EVENTS: "/events",
  LOCATION: "/locations",
  PROJECTSBUILDER: "/projects/Builder",  
  PROJECTSCONTRACTOR: "/projects/Contractor",  
  PROJECTDETAIL: "/project/:slug",
  CONTACT:"/contact",
  ERRORE: "/**",
};
